import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { faqs } from '../mockData';

export const FAQPage = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gray-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Find answers to common questions about our metal roofing services, processes, and warranties
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-padding bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4 mb-12">
              {faqs.map((faq) => (
                <AccordionItem
                  key={faq.id}
                  value={`item-${faq.id}`}
                  className="bg-white border-2 border-gray-100 rounded-lg px-6 hover:border-primary transition-colors"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-primary">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 text-base leading-relaxed pt-2">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            {/* Additional Help Section */}
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Still Have Questions?
              </h2>
              <p className="text-gray-600 mb-6">
                Our friendly team is here to help. Contact us for personalized answers to your roofing questions.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  size="lg"
                  onClick={() => navigate('/contact')}
                  className="bg-primary hover:bg-accent text-white"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Contact Us
                </Button>
                <Button
                  size="lg"
                  onClick={() => navigate('/quiz')}
                  variant="outline"
                >
                  Take Free Assessment
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Topics Section */}
      <section className="section-padding bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Popular Topics
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="font-bold text-gray-900 mb-3">Pricing & Quotes</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Learn about our competitive pricing, free quotes, and flexible financing options.
                </p>
                <Button
                  onClick={() => navigate('/contact')}
                  variant="link"
                  className="text-primary p-0"
                >
                  Get a Quote →
                </Button>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="font-bold text-gray-900 mb-3">Installation Process</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Understand what to expect during your metal roof installation project.
                </p>
                <Button
                  onClick={() => navigate('/services')}
                  variant="link"
                  className="text-primary p-0"
                >
                  View Services →
                </Button>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="font-bold text-gray-900 mb-3">Warranties & Support</h3>
                <p className="text-gray-600 text-sm mb-4">
                  Details about our comprehensive warranties and ongoing support.
                </p>
                <Button
                  onClick={() => navigate('/contact')}
                  variant="link"
                  className="text-primary p-0"
                >
                  Get a Free Quote →
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
